import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Grid from 'react-bootstrap/lib/Grid';

import EditProfileForm from '../../components/EditProfileForm';
import DashBoardSideMenu from '../../components/Dashboard/DashBoardSideMenu';

import s from './EditProfile.css';

const EditProfile = () => {

  const initialValues = useSelector(state => state?.account?.data);

  return (
    <>
      <Grid fluid className={'dashBoardContainer'}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className={'dashBoardGrid'}>
            <div>
              <DashBoardSideMenu />
            </div>
            <EditProfileForm initialValues={initialValues} />
          </Col>
        </Row>
      </Grid>
    </>
  );
}

export default withStyles(s)(EditProfile);
